import ReactModal from "../../../../__snowpack__/pkg/react-modal.js";
import styled from "styled-components";
export const ReactModalContainer = styled(ReactModal).withConfig({
  displayName: "modalstyles__ReactModalContainer",
  componentId: "sc-vegf6r-0"
})(["height:", ";width:", ";min-width:15rem;min-height:10rem;max-height:100%;", " &:focus{outline:none;}"], ({
  height
}) => height, ({
  width
}) => width, {
  transform: "var(--tw-transform)",
  zIndex: "10",
  marginLeft: "auto",
  marginRight: "auto",
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  display: "block",
  overflow: "auto",
  "--tw-shadow": "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  boxShadow: "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
  transitionProperty: "all",
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "150ms",
  overflowWrap: "break-word"
});
export const ModalContentContainer = styled.div.withConfig({
  displayName: "modalstyles__ModalContentContainer",
  componentId: "sc-vegf6r-1"
})(["max-height:calc(100% - 5rem);", ""], {
  display: "block",
  paddingTop: "1rem",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  position: "relative",
  overflow: "auto"
});
export const ModalHeaderContainer = styled.div.withConfig({
  displayName: "modalstyles__ModalHeaderContainer",
  componentId: "sc-vegf6r-2"
})(["", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  paddingTop: "1.25rem",
  paddingBottom: "1rem",
  textAlign: "center",
  width: "auto",
  display: "flex",
  justifyContent: "center"
});
export const ModalCloseContainer = styled.div.withConfig({
  displayName: "modalstyles__ModalCloseContainer",
  componentId: "sc-vegf6r-3"
})(["", ""], {
  position: "absolute",
  top: "0px",
  right: "0px",
  transitionProperty: "opacity",
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "150ms",
  padding: "0.75rem",
  zIndex: "50"
});
export const ModalActionsContainer = styled.div.withConfig({
  displayName: "modalstyles__ModalActionsContainer",
  componentId: "sc-vegf6r-4"
})(["", " > *{", " &:first-child{", "}}"], {
  display: "flex",
  justifyContent: "center",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  paddingTop: "1rem",
  paddingBottom: "1rem",
  position: "relative",
  bottom: "0px",
  width: "100%"
}, {
  marginLeft: "1rem"
}, {
  marginLeft: "0px"
});
